export class DialogController {
  isActive = false;
  data;
  params = {};
  constructor(isActive, data, params) {
    if (isActive != undefined) this.isActive = isActive;
    if (data != undefined) this.data = data;
    if (params != undefined) this.params = params;
  }

  close() {
    this.isActive = false;
  }

  open(data, params) {
    if (data != undefined) this.data = data;
    if (params != undefined) this.params = params;
    this.isActive = true;
  }
}
